export default __webpack_public_path__ + "static/download_file@2x-716f718e6d1889c64c7596add568012b.png";